/**
 * Fetch wrapper for POS backend API calls.
 * Prepends VITE_BACKEND_URL, includes credentials (session cookie),
 * and sends x-user-id / x-user-email headers from the stored session.
 */

function getStoredPosUser(): { id: string; email: string } | null {
  try {
    const raw = localStorage.getItem("sech_pos_admin");
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.user?.id || !data?.user?.email) return null;
    return { id: String(data.user.id), email: data.user.email };
  } catch {
    return null;
  }
}

export async function posApiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const baseUrl = (import.meta.env.VITE_BACKEND_URL || "").replace(
    /\/$/,
    ""
  );

  const user = getStoredPosUser();
  const isFormData = options.body instanceof FormData;

  const headers: HeadersInit = {
    // Let the browser set Content-Type (with boundary) for FormData
    ...(!isFormData && { "Content-Type": "application/json" }),
    ...(import.meta.env.VITE_INTERNAL_API_KEY && {
      "X-Internal-API-Key": import.meta.env.VITE_INTERNAL_API_KEY,
    }),
    ...(user && {
      "x-user-id": user.id,
      "x-user-email": user.email,
    }),
    ...(options.headers || {}),
  };

  return fetch(`${baseUrl}${path}`, {
    credentials: "include",
    ...options,
    headers,
  });
}
